module.exports = __webpack_public_path__ + "static/media/Alomomola_gaussian2.e4deeadb.png";